import HistoryIcon from '@mui/icons-material/History';
import { FailureItem } from './FailureItem';
import React from 'react';

interface FailureReasonsWidgetProps {
  data?: Array<{
    reason: string;
    count: number;
  }>;
}

export const FailureReasonsWidget: React.FC<FailureReasonsWidgetProps> = ({
  data = [],
}) => {
  const maxCount = data[0]?.count || 1;

  return (
    <div className='bg-white rounded-2xl shadow-lg border border-slate-100 p-8 h-full flex flex-col hover:shadow-2xl transition-all duration-300 group'>
      <div className='flex items-center gap-3 mb-8'>
        <div className='p-3 rounded-xl bg-orange-100 text-orange-600 group-hover:bg-orange-600 group-hover:text-white transition-all duration-500'>
          <HistoryIcon className='!w-5 !h-5' />
        </div>
        <div>
          <h3 className='text-base font-bold text-slate-500 uppercase tracking-wider'>
            Motivos de Incidencia (Global)
          </h3>
          <p className='text-sm text-slate-400 mt-0.5 font-medium'>
            Control de incidencias reiteradas
          </p>
        </div>
      </div>

      <div className='flex-1 overflow-y-auto pr-2 custom-scrollbar'>
        <div className='space-y-6'>
          {data.length > 0 ? (
            data.map((item, index) => (
              <FailureItem
                key={index}
                reason={item.reason}
                count={item.count}
                maxCount={maxCount}
                index={index}
              />
            ))
          ) : (
            <div className='flex flex-col items-center justify-center py-20 text-slate-300'>
              <div className='p-6 bg-slate-50 rounded-full mb-4'>
                <HistoryIcon className='!w-12 !h-12 opacity-20' />
              </div>
              <p className='text-xs font-black uppercase tracking-widest'>
                Sin incidencias
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
